module.exports = __webpack_public_path__ + "media/svg-new/ranking-2-4ec1c92b.svg";